export default "__VITE_ASSET__bzOn75ta__"